import {
  put,
  takeLatest,
  call,
  select
} from "redux-saga/effects";
import {
  fetchFeedbackFormSuccess,
  fetchFeedbackFormError,
  submitFeedbackSuccess,
  submitFeedbackError
} from "../actions/feedback.js";
import {
  FETCH_FEEDBACK_FORM,
  SUBMIT_FEEDBACK,
} from "../actions/types";
import {
  fetchFeedbackForm as fetchFeedbackFormAPI,
  submitFeedback as submitFeedbackAPI,
} from "../services/feedback.js";
import { showErrorMsg } from "../actions/snackbar";
// import { validateSession } from './session';

function* fetchFeedbackForm(action) {
  try {
    const { sessionId } = yield select((state) => state.auth || {});
    const feedbackList = yield call(fetchFeedbackFormAPI, sessionId);
    yield put(fetchFeedbackFormSuccess(feedbackList));
  } catch (error) {
    yield put(fetchFeedbackFormError(error));
    yield put(showErrorMsg(error.message));
  }
}

function* submitFeedback(action) {
  try {
    const { sessionId } = yield select((state) => state.auth || {});
    yield call(submitFeedbackAPI, action.payload, sessionId);
    // const lastOrder = yield new Promise((res) => setTimeout(() => res(), 10000));
    yield put(submitFeedbackSuccess());
  } catch (error) {
    yield put(submitFeedbackError(error));
    yield put(showErrorMsg(error.message));
  }
}


export function* watchFeedback() {
  yield takeLatest(FETCH_FEEDBACK_FORM, fetchFeedbackForm);
  yield takeLatest(SUBMIT_FEEDBACK, submitFeedback);
}
